import { Icon } from "components/ui";
import Field from "./field";
import { Group, IconButton, Input, InputElement } from "@chakra-ui/react"
import { useState } from "react";

const darkInput = {
    bg: '#16191d',
    borderColor: 'rgba(255,255,255,0.32)',
    color: 'rgba(255,255,255,0.92)',
    _placeholder: { color: 'rgba(255,255,255,0.28)' },
    _hover:  { borderColor: 'rgba(255,255,255,0.50)' },
    _focus:  { borderColor: '#f97316', boxShadow: '0 0 0 1px #f97316' },
    _invalid: { borderColor: '#ef4444', boxShadow: '0 0 0 1px #ef4444' },
    _disabled: { opacity: 0.45, cursor: 'not-allowed' },
}

export default function Password(props){

    const [ visible, setVisible ] = useState(false)

    return(
    <Field {...props}>
        <Group w="100%">
            <Input type={visible ? 'text' : 'password'} _dark={darkInput} {...props} />
            <InputElement placement="end">
                <IconButton size="xs" variant="ghost"><Icon name={!visible ? 'visible' : 'hidden'} onClick={() => setVisible(!visible)} /></IconButton>
            </InputElement>
        </Group>
    </Field>
    )
}
